(function () {
  const overlay = document.getElementById("xtra__image-popup-overlay");
  const body = document.body;

  const closeBtn = overlay.querySelector(
    "button[data-action=xtra__close-image-popup]",
  );

  let dismissed = sessionStorage.getItem("xtra__image-popup-closed");

  if (!dismissed) {
    setTimeout(() => {
      overlay.setAttribute("data-open", true);
      body.style.overflow = "hidden";
    }, 1000);
  }

  closeBtn.addEventListener("click", function () {
    overlay.removeAttribute("data-open");
    body.style.overflow = "unset";
    sessionStorage.setItem("xtra__image-popup-closed", true);
    dismissed = true;
  });
})();
